import { useSnackbar } from 'notistack';
import { IconButton, Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Link from 'next/link';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface Props {
  onClose: () => void;
  username: string;
}

export const ClaimProfileModal = ({
  onClose, username,
}: Props) => {
  const { enqueueSnackbar } = useSnackbar();

  const inviteUrl = `https://gondola.cc/signup?welcome=${username}`;

  const handleCopyToClipboard = async () => {
    navigator.clipboard.writeText(inviteUrl);
    enqueueSnackbar('Link copied to clipboard!', { variant: 'success' });
  };

  return (
    <Dialog fullWidth open>
      <div className="p-6">
        <div className="absolute right-3 top-3">
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </div>
        <h4 className="text-xl mb-2 font-bold">Claim a profile</h4>
        <div className="mb-4">
          If you know this person, invite them to Gondola!
          <div className="border-2 border-hintgray rounded-md p-2 my-2">
            {inviteUrl}
            <button type="button" onClick={handleCopyToClipboard} className="ml-2">
              <ContentCopyIcon />
            </button>
          </div>
          If this is you, or an account you manage, head over to your
          {' '}
          <Link href="/settings/accounts" className="underline">settings</Link>
          {' '}
          and auth the connected socials.
          <p className="mt-2">
            If you run into any issues or need help
            {' '}
            <Link href="/contact" className="underline">let us know!</Link>
          </p>
        </div>
      </div>
    </Dialog>
  );
};
